import axios from 'axios';
import { API_BASE_URL } from '../../config/ApiConfig';

export function logout(token) {
  return axios.post(`${API_BASE_URL.LOGIN}/logout`, null, {
    headers: { Authorization: `Bearer ${token}` },
    suppressAuthRedirect: true
  });
}

export function logoutBeacon(token) {
  // Para sendBeacon, envie o token como parâmetro
  const url = `${API_BASE_URL.LOGIN}/logout?token=${encodeURIComponent(token)}`;
  navigator.sendBeacon(url);
}
